<template>
  <div id="logoutOkPageWrapper" class="page">
    <div class="hp-row content-default flex">
      <div class="left content-column">
        <div id="logoutOkCardWrapper">
          <div class="logout-ok-card gradient-card default">

            <div class="header">
              <div class="icon"></div>
              <h4 class="title"> {{ $t('label.signOut') }} </h4>
            </div>

            <div class="body">
              <i class="icon"></i>
            </div>
          </div>
        </div>
      </div>

      <div class="right content-column">
        <div class="desc-wrapper">
          <div class="desc-default">
            <h1> {{$t('label.logoutOKStringTitle1')}} </h1>
            <p> {{$t('label.logoutOKStringDesc1')}} </p>
            <el-button class="cstm-btn-black" @click="handleSignInBtnClick">{{$t('label.signIn')}}</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script src="./logout-ok.js"></script>
<style lang="scss" src="./logout-ok.scss"></style>
